// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============================================================
                Schedules Css
===============================================================*/
.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}
body .fc {
  font-size: 1em;
}
.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5em;
}
/* .fc-icon-chevron-left:before {
  content: "î¤€";
} */
.calendar-view-page-schedule .fc-button .fc-icon {
  font-size: 25px !important;
  line-height: 17px;
  color: #717171;
}

.fc-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.25em;
}
.fc-icon {
  font-family: "fcicons" !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fc-button .fc-icon {
  vertical-align: middle;
}
.calendar-view-page-schedule .fc-button .fc-icon {
  width: 20px;
  height: 20px;
  font-size: 25px !important;
  line-height: 17px;
  color: #717171;
}
.fc-header-toolbar .fc-button-primary {
  color: #19242e;
  border-color: #2c3e50;
  outline: 0px !important;
  box-shadow: none !important;
  text-transform: capitalize;
  background: transparent;
}
.calendar-view-page-schedule .fc-button {
  padding: 0px 20px;
  border: none;
}
.fc {
  direction: ltr;
  text-align: left;
}
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}
.fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fc {
  direction: ltr;
  text-align: left;
}
button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled].rbc-btn {
  cursor: not-allowed;
}
button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;

  box-shadow: 0px 0px 10px #b5b1b1;
  padding: 5px;
}
.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}
.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rbc-rtl {
  direction: rtl;
}
.rbc-off-range {
  color: #999999;
}
.rbc-off-range-bg {
  background: #e5e5e5;
}
.rbc-header {
  overflow: hidden;
  -webkit-flex: 1 0 0%;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  border-bottom: 1px solid #ddd;
}
.rbc-header + .rbc-header {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}
.rbc-row-content {
  position: relative;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
}
.rbc-today {
  background-color: #eaf6ff;
}
.rbc-toolbar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #373a3c;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: 0px solid #ccc;
  padding: 0.375rem 1rem;
  border-radius: 25px;
  line-height: normal;
  white-space: nowrap;
}
.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: 0px 2px 5px #636363;
  background-color: #e1241a;
  color: #ffffff;
}
.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: #ffffff;
  background-color: #e1241a;
  outline: 0px;
  box-shadow: 0px 2px 5px #636363;
}
.rbc-toolbar button:focus,
.rbc-toolbar button:hover {
  color: #ffffff;
  background-color: #e1241a;
  outline: 0px;
  box-shadow: 0px 2px 5px #636363;
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}

.rbc-btn-group > button:nth-child(4n) {
  display: none;
}

.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}
.rbc-event {
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 2px 5px;
  background-color: #3174ad;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
.rbc-slot-selecting .rbc-event {
}
.rbc-event.rbc-selected {
  background-color: #265985;
}
.rbc-event:focus {
  outline: 5px auto #3b99fc;
}
.rbc-event-label {
  font-size: 80%;
}
.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}
.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}
.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}
.rbc-month-view {
  position: relative;
  border: 1px solid #ddd;

  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
  width: 100%;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
}
.rbc-month-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.rbc-month-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
  -webkit-flex-basis: 0px;
  -ms-flex-preferred-size: 0px;
  flex-basis: 0px;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #ddd;
}
.rbc-date-cell {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0px;
  flex: 1 1 0;
  min-width: 0;
  padding-right: 5px;
  text-align: right;
  min-height: 100px;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}
.rbc-row-bg {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
  overflow: hidden;
}
.rbc-day-bg {
  -webkit-flex: 1 0 0%;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}
.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}
.rbc-agenda-view {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
  overflow: auto;
}
.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #ddd;
  border-spacing: 0;
  border-collapse: collapse;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #ddd;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}
.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " Â»";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "Â« ";
}
.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}
.rbc-agenda-event-cell {
  width: 100%;
}
.rbc-time-column {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.rbc-timeslot-group {
  border-bottom: 1px solid #ddd;
  min-height: 40px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.rbc-time-gutter,
.rbc-header-gutter {
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.rbc-label {
  padding: 0 5px;
}
.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;

  top: 0;
}
.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}
.rbc-day-slot .rbc-event {
  border: 1px solid #265985;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-height: 100%;
  min-height: 20px;
  -webkit-flex-flow: column wrap;
  -ms-flex-flow: column wrap;
  flex-flow: column wrap;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}
.rbc-day-slot .rbc-event-label {
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0px;
  flex: 1 1 0;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #f7f7f7;
}
.rbc-time-view-resources .rbc-time-gutter,
.rbc-time-view-resources .rbc-time-header-gutter {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #ddd;
  z-index: 10;
  margin-right: -1px;
}
.rbc-time-view-resources .rbc-time-header {
  overflow: hidden;
}
.rbc-time-view-resources .rbc-time-header-content {
  min-width: auto;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
  -webkit-flex-basis: 0px;
  -ms-flex-preferred-size: 0px;
  flex-basis: 0px;
}
.rbc-time-view-resources .rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-view-resources .rbc-day-slot {
  min-width: 140px;
}
.rbc-time-view-resources .rbc-header,
.rbc-time-view-resources .rbc-day-bg {
  width: 140px;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0px;
  flex: 1 1 0;
  -webkit-flex-basis: 0 px;
  -ms-flex-preferred-size: 0 px;
  flex-basis: 0 px;
}
.rbc-time-header-content + .rbc-time-header-content {
  margin-left: -1px;
}
.rbc-time-slot {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}
.rbc-day-header {
  text-align: center;
}
.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}
.rbc-slot-selecting {
  cursor: move;
}
.rbc-time-view {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  border: 1px solid #ddd;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}
.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {
  border-left: 1px solid #ddd;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}
.rbc-time-header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #ddd;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #ddd;
}
.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #ddd;
}
.rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-header-content {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  min-width: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-content {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1 0 0%;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #ddd;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #ddd;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #ddd;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-select: none;
}
.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  margin-left: -8px;
  position: absolute;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^="top"]
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
}

.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^="top"]
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #f0f0f0;
}

.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  bottom: 0;
  margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper[data-placement^="top"]
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  border-bottom: none;
  border-top-color: #fff;
}

.react-datepicker-popper[data-placement^="top"]
  .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
  display: inline-block;
}

.react-datepicker {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 0.8rem;
  background-color: #fff;
  color: #000;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}

.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}

.react-datepicker-popper[data-placement^="bottom"] {
  margin-top: 10px;
}

.react-datepicker-popper[data-placement^="top"] {
  margin-bottom: 10px;
}

.react-datepicker-popper[data-placement^="right"] {
  margin-left: 8px;
}

.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}

.react-datepicker-popper[data-placement^="left"] {
  margin-right: 8px;
}

.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid #aeaeae;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  padding-top: 8px;
  position: relative;
}

.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 1.7rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 10px;
  width: 0;
  padding: 0;
  border: 0.45rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}

.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #ccc;
}

.react-datepicker__navigation--previous:hover {
  border-right-color: #b3b3b3;
}

.react-datepicker__navigation--previous--disabled,
.react-datepicker__navigation--previous--disabled:hover {
  border-right-color: #e6e6e6;
  cursor: default;
}

.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #ccc;
}

.react-datepicker__navigation--next--with-time:not(
    .react-datepicker__navigation--next--with-today-button
  ) {
  right: 80px;
}

.react-datepicker__navigation--next:hover {
  border-left-color: #b3b3b3;
}

.react-datepicker__navigation--next--disabled,
.react-datepicker__navigation--next--disabled:hover {
  border-left-color: #e6e6e6;
  cursor: default;
}

.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ccc;
}

.react-datepicker__navigation--years-previous:hover {
  border-top-color: #b3b3b3;
}

.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ccc;
}

.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 70px;
}

.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -72px;
  top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box {
  width: 70px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + (1.7rem / 2));
  overflow-y: scroll;
  padding-right: 0px;
  padding-left: 0px;
  width: 100%;
  box-sizing: content-box;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day {
  cursor: pointer;
}

.react-datepicker__day:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day--today {
  font-weight: bold;
}

.react-datepicker__day--highlighted {
  border-radius: 0.3rem;
  background-color: #3dcc4a;
  color: #fff;
}

.react-datepicker__day--highlighted:hover {
  background-color: #32be3f;
}

.react-datepicker__day--highlighted-custom-1 {
  color: magenta;
}

.react-datepicker__day--highlighted-custom-2 {
  color: green;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover {
  background-color: #1d5d90;
}

.react-datepicker__day--keyboard-selected {
  border-radius: 0.3rem;
  background-color: #2a87d0;
  color: #fff;
}

.react-datepicker__day--keyboard-selected:hover {
  background-color: #1d5d90;
}

.react-datepicker__day--in-selecting-range:not(
    .react-datepicker__day--in-range
  ) {
  background-color: rgba(33, 107, 165, 0.5);
}

.react-datepicker__month--selecting-range
  .react-datepicker__day--in-range:not(
    .react-datepicker__day--in-selecting-range
  ) {
  background-color: #f0f0f0;
  color: #000;
}

.react-datepicker__day--disabled {
  cursor: default;
  color: #ccc;
}

.react-datepicker__day--disabled:hover {
  background-color: transparent;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}

.react-datepicker__year-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover
  .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover
  .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover
  .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover
  .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ccc;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.45rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}

.react-datepicker__year-option:hover
  .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover
  .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover
  .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover
  .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover
  .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover
  .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}

.react-datepicker__close-icon::after {
  background-color: #216ba5;
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "\\00d7";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}

.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.react-datepicker__portal .react-datepicker__navigation {
  border: 0.81rem solid transparent;
}

.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #ccc;
}

.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: #b3b3b3;
}

.react-datepicker__portal .react-datepicker__navigation--previous--disabled,
.react-datepicker__portal
  .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: #e6e6e6;
  cursor: default;
}

.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #ccc;
}

.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: #b3b3b3;
}

.react-datepicker__portal .react-datepicker__navigation--next--disabled,
.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: #e6e6e6;
  cursor: default;
}

.react-confirm-alert-blur {
  filter: url(#gaussian-blur);
  filter: blur(2px);
  -webkit-filter: blur(2px);
}

.react-confirm-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999999;
  background-color: rgba(0, 0, 0, 0.6);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  opacity: 0;
  -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
  -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
  -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
}

.react-confirm-alert {
  width: 400px;
  padding: 30px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
  color: #666;
}

.react-confirm-alert-svg {
  position: absolute;
  top: 0;
  left: 0;
}

.react-confirm-alert > h1 {
  margin-top: 0;
}

.react-confirm-alert > h3 {
  margin: 0;
  font-size: 16px;
}

.react-confirm-alert-button-group {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.react-confirm-alert-button-group > button {
  outline: none;
  background: #d9534f;
  border: none;
  display: inline-block;
  padding: 6px 18px;
  color: #fff;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}

.react-confirm-alert-button-group > button:nth-child(1) {
  outline: none;
  background: #0088cc;
  border: none;
  display: inline-block;
  padding: 6px 18px;
  color: #fff;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}

@-webkit-keyframes react-confirm-alert-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-moz-keyframes react-confirm-alert-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-o-keyframes react-confirm-alert-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes react-confirm-alert-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.calender-rightside {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.calendar-view-page-schedule .calender-rightside {
  height: auto;
}

.calender-rightside .ant-select {
  width: 100%;
  border-radius: 0px;
}
.calender-rightside .ant-select-selection {
  background-color: #e1241a;
  color: #ffffff;
  border-radius: 0px;
}
.calender-rightside .ant-select-arrow {
  color: #ffffff;
}
.calender-rightside .item p {
  color: #000000;
  font-size: 12px;
}
.calender-rightside .item p a {
  width: 20px;
  display: inline-block;
  color: green;
}
.calender-rightside .item p b {
  font-weight: 400;
}
.calender-rightside .item p span {
  background: #ffffff;
  color: #06b4e0;
  padding: 2px 5px;
  font-size: 11px;
  width: 70px;
  display: inline-block;
  text-align: center;
  float: right;
}

.soloprofilepage .progressbar {
  margin-top: 40px;
}

.soloprofilepage .progressbar .stepwizard-step p {
  margin-top: 10px;
  margin-left: -15%;
  font-size: 10px;
}
.soloprofilepage .progressbar .stepwizard-step.p2 p {
  margin-left: -5%;
}

.soloprofilepage .progressbar .stepwizard-row {
  display: table-row;
  width: 100%;
}

.soloprofilepage .progressbar .stepwizard {
  display: table;
  width: 80%;
  position: relative;
  margin: auto;
}

.soloprofilepage .progressbar .stepwizard-step button[disabled] {
  opacity: 1 !important;
  filter: alpha(opacity=100) !important;
}

.soloprofilepage .progressbar .stepwizard-row:before {
  top: 25%;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 68%;
  height: 1px;
  background-color: #ccc;
  z-order: 0;
}

.soloprofilepage .progressbar .stepwizard-step {
  display: table-cell;
  position: relative;
  width: 330px;
}

.soloprofilepage .progressbar .btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
  background: #f0f1f6;
}
.soloprofilepage .progressbar .btn-primary {
  color: #fff;
  background-color: #e1362d;
  width: 40px;
  height: 40px;
  line-height: 20px;
  border-radius: 50%;
  border: 0px;
  padding: 10px;
}
.soloprofilepage .progressbar .btn-primary .fa-circle {
  color: #ffffff;
}
.soloprofilepage .progressbar .fa-circle {
  color: #e1362d;
}

/*======================= popup ========================*/
.myModalconfirmdes .close {
  float: inherit;
  text-align: right;
  background: #dadbe6;
  opacity: 1;
  display: block;
  margin: auto;
  margin-right: 0px;
  margin-top: 10px;
  color: #ffffff;
  padding: 0px 0px 5px 0px;
  width: 35px;
  border-radius: 50%;
  height: 35px;
  line-height: 30px;
  text-align: center;
  top: 0px;
  position: absolute;
  font-size: 35px;
  font-weight: 100;
  right: 10px;
}
.myModalconfirmdes .close:hover,
.myModalconfirmdes .close:focus {
  opacity: 1 !important;
  background: #bcbaba;
  outline: 0px;
}
.myModalconfirmdes .modal-content {
  background: #f0f1f7;
  border-radius: 10px;
  width: 600px;
  margin: auto;
  border: 0px;
  margin-top: 20px;
}

.myModalconfirmdes .modal-content.modal-content22 {
  color: #e1362d;
  font-size: 32px;
  text-align: center;
  margin: 0 10px;
  width: calc(100% - 20px);
  border-radius: 0px;
  padding: 10px 0;
  margin-bottom: 2px;
  background: transparent;
  border: 0px;
  padding-top: 30px;
}
.myModalconfirmdes .modal-content.modal-content22 b {
  font-weight: normal;
}
.myModalconfirmdes .modal-title {
  font-size: 28px;
  font-weight: 400;
  padding-right: 20px;
}
.myModalconfirmdes p {
  margin: 0px;
  padding-top: 10px;
}
.myModalconfirmdes p.p1 {
  font-size: 12px;
  font-weight: bold;
}
.myModalconfirmdes p.p2 {
  background: #fff;
  padding: 5px 10px;
  color: #cac7c7;
  border: 1px solid #cccccc;
  border-radius: 20px;
}
.myModalconfirmdes p.p2select {
  padding: 0px;
  color: #cac7c7;
  border: 0px solid #cccccc;
}
.myModalconfirmdes p.p2select .custom-select {
  border-radius: 40px;
  color: #cac7c7;
  height: 32px;
  padding: 4px 10px;
}
.myModalconfirmdes p.p2select input {
  border-radius: 40px;
  color: #cac7c7;
  height: 32px;
  padding: 4px 10px;
}
.myModalconfirmdes .row.no-gutters {
  border-bottom: 1px solid #cccccc;
  padding: 10px 0px;
  margin: 0px 10px;
}
.myModalconfirmdes .row.no-gutters:last-child {
  border: 0px;
}
.myModalconfirmdes p.p3 {
  text-align: right;
  font-size: 18px;
  font-weight: 600;
  color: #8a8383;
}

.myModalconfirmdes ul li {
  display: inline-block;
  padding: 1px 4px;
  border: #ffff;
  background: #ffffff;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  line-height: 27px;
  text-align: center;
  border: 1px solid #cccccc;
}
.myModalconfirmdes ul li a {
  display: block;
  color: #827d7d;
  text-decoration: none;
  font-size: 14px;
}
.myModalconfirmdes ul li.active {
  background: #dcd9d9;
  border-color: #2f2c2c;
}
.myModalconfirmdes ul li.active a {
  color: #222222;
  font-weight: 500;
}
.myModalconfirmdes .modal-header,
.myModalconfirmdes .modal-footer {
  background: #ffffff;
  padding-bottom: 5px;
}

#myModalService.myModalconfirmdes .modal-dialog {
  height: 100%;
}

#scheduleappointment .fc-button-primary {
  background: transparent;
  border: 0px;
  color: #071822;
  text-transform: capitalize;
  font-size: 16px;
  padding: 5px 15px;
  letter-spacing: 1px;
}
#scheduleappointment .fc-button-primary.fc-button-active,
#scheduleappointment .fc-button-primary:not(:disabled):active:focus,
#scheduleappointment .fc-button-primary:not(:disabled).fc-button-active:focus,
#scheduleappointment .fc-button-primary:hover {
  box-shadow: 0px 2px 5px #636363;
  background-color: #e1241a;
  color: #ffffff;
  border-radius: 30px;
  outline: 0px;
  opacity: 1;
}
#scheduleappointment .fc-toolbar h2 {
  font-size: 1.75em;
  margin: 0;
  font-size: 16px;
}
#scheduleappointment .fc-timeGrid-view .fc-day-grid {
  display: none;
}
#scheduleappointment hr.fc-divider {
  display: none;
}
#scheduleappointment .fc-nonbusiness {
  background: #cecece;
}
#act #scheduleappointment .fc-event .fc-content {
  color: #fff;
  font-size: 12px;
  text-align: center;
}
#scheduleappointment .fc {
  font-size: 1em;
  box-shadow: 0px 0px 10px #b5b1b1;
  padding: 5px;
}
#scheduleappointment .fc-toolbar.fc-header-toolbar {
  margin-bottom: 5px;
}
.eventColor {
  background: #cecece;
}

/*
 spinner
*/

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 50px;
  height: 50px;
  margin-top: -0.5em;

  border: 5px solid rgba(33, 150, 243, 1);
  border-radius: 100%;
  border-bottom-color: transparent;
  -webkit-animation: spinner 1s linear 0s infinite;
  animation: spinner 1s linear 0s infinite;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media (max-width: 1300px) {
  .myModalconfirmdes .modal-content.modal-content22 {
    font-size: 25px;
  }
  .myModalconfirmdes .modal-title {
    font-size: 20px;
  }
  .myModalconfirmdes .modal-header img {
    width: 35px;
  }
  .myModalconfirmdes .row.no-gutters {
    padding: 5px 10px;
  }
  .myModalconfirmdes p.p2 {
    height: 32px;
    padding: 3px 10px;
  }
}
@media (max-width: 1100px) {
  #scheduleappointment .fc-button-primary {
    font-size: 12px;
    padding: 3px 10px;
  }
  #scheduleappointment .fc-toolbar h2 {
    font-size: 12px;
  }
  .calender-rightside .item p {
    display: flex;
    justify-content: space-between;
    text-align: center;
    font-size: 10px;
  }
  .calender-rightside .item p span {
    height: 20px;
  }
  .calendar-view-page-schedule .main-view .item ul.hours-view li {
    font-size: 12px;
  }
}

@media screen and (max-width: 991px) {
  #scheduleappointment .fc-button-primary {
    font-size: 10px;
    padding: 3px 10px;
  }
  #scheduleappointment .fc-toolbar h2 {
    font-size: 10px;
  }
  .fc th {
    font-size: 10px;
  }
  .fc-ltr .fc-axis {
    font-size: 11px;
    text-align: center;
  }
  .calender-rightside .item p span {
    display: block;
    width: 100%;
    margin-top: 5px;
    float: inherit;
  }
  .calender-rightside .item p {
    font-size: 9px;
    font-weight: bold;
    display: block;
  }
  .soloprofilepage .progressbar .stepwizard {
    width: 100%;
  }
  .soloprofilepage .progressbar .stepwizard-step p {
    font-weight: bold;
    font-size: 10px;
  }

  .soloprofilepage .profiletabone .property-rrswatch a {
    font-size: 10px;
  }
  .soloprofilepage .profiletabone .property-rrswatch label {
    position: relative;
    top: 4px;
  }
  .soloprofilepage .profiletabone i {
    padding-top: 10px;
    padding-bottom: 20px;
    font-size: 10px;
    color: #8a8585;
    text-align: center;
    font-weight: 700;
  }
  .calendar-view-page-schedule .main-view .item ul {
    margin: auto;
  }
  .calendar-view-page-schedule .main-view .item ul li {
    margin-right: 15px;
  }
}
.myModalconfirmdes .modal-dialog {
  height: calc(100vh - 80px);
}
@media screen and (max-width: 767px) {
  .myModalconfirmdes .modal-content {
    width: 100%;
  }
  .myModalconfirmdes .modal-content.modal-content22 {
    font-size: 18px;
  }
  .myModalconfirmdes .close {
    width: 27px;
    height: 28px;
    line-height: 28px;
    font-size: 20px;
  }
  .myModalconfirmdes .modal-title {
    font-size: 15px;
    font-weight: 600;
  }
  .myModalconfirmdes p.p2 {
    margin-bottom: 10px;
  }
  .myModalconfirmdes p {
    text-align: center;
  }
  .myModalconfirmdes p.p3 {
    text-align: center;
  }
  .myModalconfirmdes .modal-dialog {
    height: auto;
  }
  .myModalconfirmdes .modal-footer .btn {
    /* font-size: 10px;
    font-weight: bold;
    padding: 5px 15px;
    margin-top: 0px !important; */
  }
  #moveDelete .modal-title {
    font-size: 15px;
    font-weight: 700;
  }
  #moveDelete .input-group {
    flex-direction: column;
  }
  #moveDelete .react-datepicker__input-container,
  #moveDelete .input-group-prepend {
    display: block;
  }
  .react-confirm-alert {
    width: 90%;
  }
  .calendar-view-page-schedule .main-view .item ul.hours-view {
    flex-direction: column;
  }
}

@media (min-width: 320px) {
  .myModalconfirmdes .modal-dialog {
    max-width: 80%;
    margin: 1.75rem auto;
    margin-top: 50px;
    background: #ffffff;
  }
}

#moveDelete .input-group-prepend {
  float: left;
  margin-bottom: 15px;
}
#moveDelete .react-datepicker-wrapper {
  width: 100%;
}
#moveDelete .react-datepicker__input-container {
  width: 100%;
}

#moveDelete .col-form-label {
  text-align: right;
}

/**--------------------------28/01/2020 ------------------**/

@media (max-width: 991px) {
  .soloprofilepage .fc-toolbar.fc-header-toolbar h2 {
    font-size: 16px;
    font-weight: 700;
  }
}
@media (max-width: 767px) {
  .soloprofilepage .fc-toolbar.fc-header-toolbar h2 {
    padding-top: 10px;
  }
  #myModalService.myModalconfirmdes ul {
    text-align: center !important;
  }
}

.new_modal_pop .form-para p.p2 {
  height: 38px;
  background: #ffffff;
  border: 1px solid #cccccc;
  padding: 7px 10px;
  border-radius: 5px;
  color: #4e4e4e;
}
.new_modal_pop .form-para p.p3 input {
  height: 38px;
  background: #ffffff;
  border: 1px solid #cccccc;
  padding: 7px 10px;
  border-radius: 5px;
  color: #4e4e4e;
}
.new_modal_pop .form-para .ant-select-selection--multiple ul {
  margin: 0px;
}
.new_modal_pop .form-para .ant-select-selection--multiple > ul > li,
.new_modal_pop
  .form-para
  .ant-select-selection--multiple
  .ant-select-selection__rendered
  > ul
  > li {
  height: 30px;
  margin-top: 3px;
  line-height: 26px;
}
/** properties thumbnail checkkk css*/
.new_modal_pop .properties_list ul {
  list-style-type: none;
  text-align: left;
  padding: 0px;
  margin: 0;
  padding-top: 10px;
}

.new_modal_pop .properties_list ul li {
  display: inline-block;
  width: auto;
  height: auto;
  background: transparent;
  border: 0px;
  position: relative;
}

.new_modal_pop .properties_list input[type="checkbox"][id^="myCheckbox"] {
  display: none;
}

.new_modal_pop .properties_list input[type="checkbox"][id^="mybox"] {
  display: none;
}

.new_modal_pop .properties_list label {
  border: 2px solid #fff;
  padding: 0px;
  display: block;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

.new_modal_pop .properties_list label:before {
  background-color: white;
  color: white;
  content: " ";
  display: block;
  border-radius: 50%;
  border: 1px solid grey;
  position: absolute;
  top: -6px;
  left: -6px;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 23px;
  transition-duration: 0.4s;
  transform: scale(0);
  font-size: 20px;
}

.new_modal_pop .properties_list label img {
  height: 135px;
  width: 140px;
  transition-duration: 0.2s;
  transform-origin: 50% 50%;
}

.new_modal_pop .properties_list :checked + label {
  border-color: #ffb0b0;
}

.new_modal_pop .properties_list :checked + label:before {
  content: "âœ“";
  background-color: #e32726;
  transform: scale(1);
  border-color: #e32726;
  z-index: 1;
  font-size: 20px;
  top: -6px;
  left: -6px;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 23px;
}

.new_modal_pop .properties_list :checked + label img {
  z-index: -1;
}
.new_modal_pop .properties_list label p {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 13px;
  line-height: 16px;
  bottom: 0px;
  width: 100%;
  color: #ffffff;
  padding: 10px;
  word-break: break-word;
  justify-content: center;
  align-items: center;
  height: 100%;
  bottom: 0px;
  text-align: center;
}
.new_modal_pop .properties_list label:hover {
  background: rgba(0, 0, 0, 1);
}
.new_modal_pop .properties_list label:hover img {
  opacity: 0.3;
}
.new_modal_pop .properties_list label:hover p {
  display: flex !important;
  transition: all 0.3s;
}
.new_modal_pop .properties_list .p_list {
  position: relative;
  margin-top: 10px;
  border: 1px solid #dad8d8;
  border-radius: 5px;
}
.new_modal_pop .properties_list .p_list h1 {
  font-size: 18px;
  padding-top: 10px;
  position: absolute;
  top: -13px;
  background: #f2f2f2;
  padding: 0px 5px;
  left: 15px;
}
.new_modal_pop .ul_select_list {
  border: 1px dashed #ededed;
  font-weight: 400;
  white-space: nowrap;
  color: #d0d0d0;
  font-size: 17px;

  padding: 0;
  padding-left: 16px;
  padding-right: 0px;
  min-height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
}

.new_modal_pop .ul_select_list span.main_span .ant-select.ant-select-enabled {
  width: 200px !important;
  padding-right: 12px;
}
.new_modal_pop .ul_select_list span.main_span .ant-select-selection--multiple {
  border: 0px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
}
.new_modal_pop
  .ul_select_list
  span.main_span
  .ant-select-selection--multiple
  > ul
  > li,
.new_modal_pop
  .ul_select_list
  span.main_span
  .ant-select-selection--multiple
  .ant-select-selection__rendered
  > ul
  > li {
  width: 100% !important;
}
.new_modal_pop .ul_select_list span.main_span {
  position: relative;
}
.new_modal_pop .ul_select_list span.main_span .fa.fa-caret-down {
  color: #717171;
  position: absolute;
  top: 13px;
  right: 20px;
  display: none;
}
.new_modal_pop .next_input .floating-label {
  position: relative;
  height: 42px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 0px;
  color: #4e4e4e;
}
.new_modal_pop .next_input .floating-label input.form-control {
  border: 0px;
  padding: 5px 10px 5px 10px;
  height: 40px;
  border-radius: 0px;
  color: #717171;
  line-height: 35px;
}
.new_modal_pop .next_input .floating-label .fa.fa-map-marker {
  position: absolute;
  top: 0;
  right: 0px;
  font-size: 20px;
  color: #d6d4d4;
  background: #fbfbfb;
  padding-top: 10px;
  padding-left: 16px;
  bottom: 0px;
  width: 40px;
}
.new_modal_pop .floating-label .fa.fa-map-marker {
  position: absolute;
  top: 20px;
  right: 0px;
  font-size: 20px;
  color: #d6d4d4;
  padding-top: 10px;
  padding-left: 16px;
  bottom: 0px;
  width: 40px;
}
.new_modal_pop .ul_select_list.text_overfloww .main_span {
  width: 250px;
  padding-top: 7px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: #797979;
  text-align: right;
  padding-right: 15px;
  white-space: initial;
}
.new_modal_pop .ul_select_list.text_overfloww .main_span:hover {
  white-space: initial;
  transition: All 0.3s;
}
.new_modal_pop .properties_list .owl-carousel.owl-drag .owl-item {
  text-align: center;
}
.calendarIndicators-view-top {
  position: relative;
}
.calendarIndicators-view {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 49px;
  left: 0px;
  right: 0px;
}
ul.calendarIndicators.main {
  box-shadow: 0px 0px 4px #b7b7b7;
  line-height: 20px;
  height: auto;
  padding: 0px !important;
  border-radius: 5px;
}
ul.calendarIndicators.main li {
  color: #333333;
  padding: 7px 10px 5px 10px;
  line-height: 15px;
  margin: 0;
}
ul.calendarIndicators.main2 li span {
  font-weight: 500;
  color: #000000;
}
ul.calendarIndicators.main2 li {
  color: #ffffff;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.2px;
  outline: 0px;
  box-shadow: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 5px;
  padding: 7px 10px;
  margin-top: 0px;
}
ul.calendarIndicators.main2 li:first-child {
  background: #6effaa;
  border-bottom: 1px solid #cccccc;
}
ul.calendarIndicators.main2 li:last-child {
  background: #4bc5ff;
  margin: 0px;
}
.main_content .fc-toolbar.fc-header-toolbar {
  margin-bottom: 50px;
}

@media (max-width: 991px) {
  .main_content .fc-toolbar.fc-header-toolbar {
    margin-bottom: 65px;
  }
  ul.calendarIndicators {
    width: 48%;
  }
  ul.calendarIndicators.main2 li {
    padding: 7px 5px;
  }
  ul.calendarIndicators.main li {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  #myModalService.new_modal_pop .btn.theme-btn {
    margin: auto;
    margin-bottom: 15px;
    display: inline-block;
    width: auto;
  }
  .main_content .fc-toolbar.fc-header-toolbar {
    margin-bottom: 120px;
  }
  .calendarIndicators-view {
    top: 140px;
    flex-direction: column;
  }
  ul.calendarIndicators {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  ul.calendarIndicators.main {
    margin-bottom: 13px;
  }
}
@media (max-width: 500px) {
  .modal.new_modal_pop .modal-content h6::before {
    display: none;
  }
  .new_modal_pop .ul_select_list {
    flex-direction: column;
  }
  .new_modal_pop .ul_select_list span.main_span .ant-select.ant-select-enabled {
    width: 100% !important;
  }
  .new_modal_pop .properties_list .properties_list_owl-carousel ul {
    width: 70%;
    margin: auto;
  }
  #myModalService.new_modal_pop .btn.theme-btn {
    display: block;
    width: 200px;
    margin: auto !important;
    margin-bottom: 10px !important;
  }
}
.new_modal_pop .properties_list input[type="checkbox"][id^="sabox"] {
  display: none;
}

.fc-time-grid-event .fc-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  text-align: center;
  color: #e0e0e0;
  font-size: 13px;
}
.fc-scroller.fc-time-grid-container .fc-nonbusiness {
  background: #b1b1b1;
}
.fc-time-grid .fc-slats td {
  background: rgba(202, 202, 202, 0.3);
  background: transparent;
}
.fc-header-toolbar .fc-button-primary,
.fc-header-toolbar .fc-button-primary:focus {
  color: #19242e;
  border-color: #2c3e50;
  outline: 0px !important;
  box-shadow: none !important;
  text-transform: capitalize;
  background: transparent;
}
.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5em;
}
.fc-header-toolbar .fc-button-primary:hover {
  color: #ffffff;
  border-color: #2c3e50;
  background: #19242e;
  transition: all 0.5s;
}
.fc-header-toolbar .fc-button-primary:disabled,
.fc-header-toolbar .fc-button-primary:disabled:hover {
  color: #19242e;
  background-color: transparent;
  border-color: #2c3e50;
  opacity: 0.3;
  cursor: not-allowed;
}
button:not(:disabled) {
  cursor: pointer;
}
.calendar-view-page-schedule .fc-button {
  padding: 0px 20px;
  border: none;
}
.fc-button-group > .fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.fc-button-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.calendar-view-page-schedule .main-view .item h2 {
  margin: 5px 0px;

  color: #333333;
  text-align: center;
}
.calendar-view-page-schedule .main-view .item .calendar h2 {
  font-size: 18px;
}
.calendar-view-page-schedule .fc-button .fc-icon {
  font-size: 25px !important;
  line-height: 17px;
  color: #717171;
}

/* .fc-icon-chevron-left:before {
  content: "î¤€";
} */
.calendar-view-page-schedule .fc-button .fc-icon {
  width: 20px;
  height: 20px;
  font-size: 25px !important;
  line-height: 17px;
  color: #717171;
}
.calendar-view-page-schedule .fc-button {
  padding: 0px 20px;
  border: none;
}
.fc-time-grid .fc-time-grid-event.fc-event {
  border: 0px;
}
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-content,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-list-heading td {
  border-color: #cacaca !important;
}
.fc-view .fc-body {
  background: #ffffff;
}
.fc-time-grid .fc-slats td.fc-axis {
  background: #f0f1f7;
}
.fc-timeGrid-view .fc-day-grid {
  display: none;
}
hr.fc-divider.fc-widget-header {
  display: none;
}
.fc-view-container * {
}
.fc-view-container .fc-day-header.fc-widget-header {
  /* background: #19242e;
  color: #ffffff; */
  font-weight: 700;
  padding: 5px;
  font-size: 13px;
}
.fc {
  direction: ltr;
  text-align: left;
}
.fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fc-time-grid .fc-slats td.fc-axis {
  /* background: #19242e;
  color: #ffffff; */
  font-weight: 700;
  padding: 5px;
  font-size: 12px;
}
.fc-axis.fc-widget-header {
  position: relative;
}
.fc-axis.fc-widget-header::after {
  content: "\\f017";
  font-family: FontAwesome;
  position: absolute;
  top: 3px;
  left: 50%;
  font-size: 16px;
  font-weight: 100;
  transform: translateX(-50%);
}

.fc-view-container .fc-title {
  /* color: red; */
  font-size: 9px;
  font-weight: 900;
}

.ds-profile-page .calendar-view-page-schedule h1 {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaaa;
  margin-bottom: 0px;
}
.calendar-view-page-schedule .main-view {
  display: flex;
  justify-content: space-between;
}

.calendar-view-page-schedule .main-view .item {
  padding: 10px 20px;
  width: 25%;
}
.calendar-view-page-schedule .main-view .item:nth-child(2) {
  width: 50%;
}
.calendar-view-page-schedule .main-view .item .image-circle-view {
  width: 170px;
  height: 170px;
  overflow: hidden;
  margin: auto;
  border-radius: 50%;
  border: 3px solid #cccc;
  margin-bottom: 15px;
}
.calendar-view-page-schedule .main-view .item .image-circle-view img {
  width: 100%;
  height: 100%;
}
.calendar-view-page-schedule .main-view .item .bg-color {
  background: #ffffff;
  border-radius: 7px;
  padding: 30px 15px;
  box-shadow: 0px 0px 4px #b7b7b7;
}
.calendar-view-page-schedule .main-view .item img {
  width: 100%;
  margin-bottom: 20px;
}

.calendar-view-page-schedule .main-view .item h1 {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaaa;
  margin-bottom: 0px;
}
.calendar-view-page-schedule .main-view .item h2 {
  margin: 5px 0px;
  font-size: 30px;
  color: #333333;
  text-align: center;
}

.calendar-view-page-schedule .main-view .item h3 {
  margin: 5px 0px;
  font-size: 15px;
  color: #7d7d7d;
  font-weight: 400;
}

.calendar-view-page-schedule .main-view .item ul {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
}
.calendar-view-page-schedule .main-view .item ul li {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 0px;
  display: flex;
  padding-bottom: 5px;
  margin-right: 0px;
}
.calendar-view-page-schedule .main-view .item .bg-color.bg-color2 {
  background: #d7c7fa;
  color: #000000;
}
.calendar-view-page-schedule .main-view .item ul.main {
  box-shadow: none;
}
.calendar-view-page-schedule .main-view .item ul.main li {
  color: #000000;
  padding: 5px 10px;
  font-size: 15px;
  letter-spacing: 0.3px;
  font-weight: 500;
  line-height: 18px;
}
.calendar-view-page-schedule .main-view .item ul li i {
  color: #aaaaaa;
  position: relative;
  top: 1px;
  margin-right: 10px;
  font-size: 20px;
}

.calendar-view-page-schedule .main-view .item ul.hours-view li {
  justify-content: space-between;
  margin: 0px 0px;
  font-size: 13px;
  background: transparent;
  padding: 10px 0px;
  border-radius: 0px;
}
.calendar-view-page-schedule .main-view .item h4 {
  margin: 5px 0px;
  font-size: 20px;
  color: #6e6e6e;
  font-weight: 500;
}
.calendar-view-page-schedule .main-view .item h5 {
  margin: 5px 0px;
  font-size: 17px;
  color: #121212;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 30px;
}
.calendar-view-page-schedule .main-view .item h6 {
  margin: 5px 0px;
  font-size: 18px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 15px;
  border-bottom: 2px solid #ccc;
  padding-bottom: 5px;
}
.calendar-view-page-schedule .main-view .item .clr-slots-view-bg {
  background: #ffffff;
  padding: 20px 15px;
  border-radius: 10px;
  box-shadow: 0px 0px 4px #b7b7b7;
}
.calendar-view-page-schedule .a-slots {
  max-height: 200px;
  overflow: auto;
  margin-bottom: 20px;
}
.calendar-view-page-schedule .y-appointment {
  max-height: 240px;
  overflow: auto;
  margin-bottom: 20px;
}
.calendar-view-page-schedule .main-view .item .btn {
  display: block;
  border: 1px solid #121212;
  width: 100%;
  max-width: 240px;
  margin-bottom: 15px;
  color: #151515;

  font-weight: 500;
  padding: 10px 20px;
  background: #dbdbdb;
}
.calendar-view-page-schedule .fc-button {
  padding: 0px 20px;
  border: none;
}
.calendar-view-page-schedule .fc-button .fc-icon {
  width: 20px;
  height: 20px;
  font-size: 25px !important;
  line-height: 17px;
  color: #717171;
}
.calendar-view-page-schedule .main-view .item .calendar h2 {
  font-size: 18px;
}
.calendar-view-page-schedule .main-view .fc-scroller.fc-day-grid-container {
  height: 100% !important;
  overflow: auto !important;
}
.calendar-view-page-schedule .main-view .calendar .fc th {
  border: 0px;
  text-align: center;
  padding: 10px 5px;
}
.calendar-view-page-schedule .fc-view-harness.fc-view-harness-active {
  min-height: 600px;
}
.calendar-view-page-schedule .fc .fc-daygrid-day.fc-day-today {
  height: auto;
}

.calendar-view-page-schedule .main-view .calendar .fc td {
  border: 0px;
  text-align: center;
}
.calendar-view-page-schedule .fc-view .fc-body {
  background: #f7f7f7;
}
.calendar-view-page-schedule .fc-nonbusiness {
  background: #f7f7f7;
}
.calendar-view-page-schedule .fc-row .fc-bg td {
  border-radius: 10px;
}
.calendar-view-page-schedule .fc-highlight {
  background: #2facf5;
  opacity: 0.3;
  border-radius: 10px;
}
.calendar-view-page-schedule .fc-unthemed td.fc-today {
  background: #e19493;
}
.calendar-view-page-schedule
  .main-view
  .fc-ltr
  .fc-dayGrid-view
  .fc-day-top
  .fc-day-number {
  float: inherit;
}
.calendar-view-page-schedule .main-view .fc-dayGrid-view .fc-body .fc-row {
  display: flex;
  align-items: center;
}
.main_cal_indicate ul.indicators li {
  display: inline-flex !important;
  align-items: center;
}
.main_cal_indicate ul.indicators li b {
  letter-spacing: -2px;
  padding: 0px 10px;
}
.main_cal_indicate ul.indicators li span {
  background: #e7e7e7;
  height: 15px;
  width: 40px;
  display: inline-block;
  border-radius: 7px;
}
.main_cal_indicate ul.indicators li.one span {
  background: repeating-linear-gradient(
    45deg,
    #7f7f7f,
    #7f7f7f 8px,
    #7f7f7f 8px,
    #7f7f7f 20px
  );
}
.main_cal_indicate ul.indicators li.green span {
  background: repeating-linear-gradient(
    45deg,
    #1967b3,
    #1967b3 8px,
    #1967b3 8px,
    #1967b3 20px
  );
}
.main_cal_indicate ul.indicators li.white span {
  background: repeating-linear-gradient(
    45deg,
    #ffffff,
    #ffffff 8px,
    #ffffff 8px,
    #ffffff 20px
  );
}
.calendar-view-page-schedule ul.time-slot {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
}
.calendar-view-page-schedule ul.time-slot li {
  margin-bottom: 10px !important;
}
.calendar-view-page-schedule ul.time-slot li a {
  background: #2facf5;
  background: #1d66b3;
  color: #fff;
  width: 100%;
  min-height: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  flex-direction: column;

  font-size: 15px;
  padding: 10px 15px;
}
.calendar-view-page-schedule .fc-dayGridMonth-button {
  display: none;
}
.calendar-view-page-schedule .fc-header-toolbar .fc-button-primary:hover {
  color: #ffffff;
  border-color: #2c3e50;
  background: #19242e;
  transition: all 0.5s;
  background: transparent;
  border: none;
}
.calendar-view-page-schedule .fc td.fc-past {
  color: #9f9f9f;
}
.calendar-view-page-schedule .fc-event {
  /* position: relative; */
  display: block;
  font-size: 0.85em;
  line-height: 1.4;
  border-radius: 11px !important;
  border: 0px solid #3788d8;
  height: 12px;
  width: 12px;
  text-align: center;
  padding: 0px;
  margin: auto;
  opacity: 1;
  position: absolute;
  bottom: -35px;
}
.calendar-view-page-schedule .main-view .calendar .fc td.avaliableDay {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 0px 5px #ebebeb;
}
.calendar-view-page-schedule .main-view .item .main_cal_indicate ul li {
  margin: 0px 20px;
}
@media (max-width: 1199px) {
  .calendar-view-page-schedule .main-view .item .image-circle-view {
    width: 150px;
    height: 150px;
  }
  .calendar-view-page-schedule .main-view .item h2 {
    font-size: 20px;
    font-weight: 700;
  }
}

@media (max-width: 991px) {
  .calendar-view-page-schedule .main-view {
    flex-direction: column;
  }
  .calendar-view-page-schedule .main-view .item {
    width: 100%;
    text-align: center;
  }
  .calendar-view-page-schedule .main-view .item ul {
    text-align: left;
  }
  .calendar-view-page-schedule .main-view .item:nth-child(2) {
    width: 100%;
    padding: 10px 5px;
  }
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar {
    flex-direction: row;
  }
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-left,
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-right {
    width: auto;
  }
  .calendar-view-page-schedule .main-view .item .btn {
    margin: auto;
    margin-bottom: 15px;
  }
  .calendar-view-page-schedule ul.time-slot li a {
    max-width: 250px;
    margin: auto;
  }
}

@media (max-width: 767px) {
  .calendar-view-page-schedule .main-view {
    flex-direction: column;
  }
  .calendar-view-page-schedule .main-view .item {
    width: 100%;
    text-align: center;
  }
  .calendar-view-page-schedule .main-view .item ul {
    text-align: left;
  }
  .calendar-view-page-schedule .main-view .item:nth-child(2) {
    width: 100%;
    padding: 10px 5px;
  }
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar {
    flex-direction: row;
  }
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-left,
  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-right {
    width: auto;
  }
  .calendar-view-page-schedule .fc-dayGrid-view .fc-body .fc-row {
    min-height: 43px;
  }
  .calendar-view-page-schedule .main-view .item .btn {
    margin: auto;
    margin-bottom: 15px;
  }
  .main_cal_indicate ul.indicators li {
    margin-right: 0px !important;
    width: 100%;
  }
  .calendar-view-page-schedule .fc-event {
    height: 10px;
    width: 10px;
  }
}

@media (max-width: 400px) {
  .main_cal_indicate ul.indicators li {
    font-size: 14px;
  }

  .calendar-view-page-schedule .fc-event {
    height: 8px;
    width: 8px;
  }
}
.calendar-view-page-schedule .fc-content-skeleton tr:nth-child(2) {
  display: none;
}
.calendar-view-page-schedule .past {
  border-radius: 10px;
  background-color: rgb(11, 0, 75);
  height: 50%;
}
.calendar-view-page-schedule .activeDay {
  border-radius: 10px;
  background-color: #e19493 !important;
  height: 100%;
  margin: 0px 2px 0px 2px;
}
/* .activeDay {
  background-color: red;
} */
.calendar-view-page-schedule .fc-day-grid {
  min-height: 100%;
}
.calendar-view-page-schedule .fc-bg {
  margin: 2px;
}
@-moz-document url-prefix() {
  .calendar-view-page-schedule .activeDay {
    height: 100%;
  }
  .calendar-view-page-schedule .main-view .calendar .fc td {
    height: 100%;
  }
}
/* =====modalpop styles */
.new_modal_pop h6 {
  color: #505050;
  text-align: center;
  font-size: 20px;
  position: relative;
  margin-bottom: 25px;
}
.modal-body {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
}
.new_modal_pop .ul_select_list {
  border: 1px dashed #ededed;
  font-weight: 400;
  white-space: nowrap;
  color: #d0d0d0;
  font-size: 17px;

  padding: 0;
  padding-left: 16px;
  padding-right: 0px;
  min-height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
}
.new_modal_pop ul.appoint_list li a {
  position: relative;
  display: block;
  height: 40px;
  line-height: 40px;
  padding: 0;
  padding-left: 16px;
  padding-right: 56px;
  text-decoration: none;
  font-weight: 400;
  white-space: nowrap;
  color: #d0d0d0;
  font-size: 17px;

  border: 1px dashed #ededed;
}
.new_modal_pop ul.appoint_list li a span {
  position: absolute;
  right: 16px;
  top: 0;
  color: #717171;
}

.new_modal_pop ul.appoint_list li {
  position: relative;
  list-style-type: none;
}
.new_modal_pop ul.appoint_list {
  padding: 0px;
  margin: 0px;
}
.new_modal_pop .ul_select_list span.main_span {
  position: relative;
}
.pd-y-50 {
  padding: 50px 0px;
}
.width-60per {
  width: 60% !important;
  margin: auto;
}

.calendar-view-page-schedule .fc .fc-col-header-cell-cushion {
  display: inline-block;
  padding: 2px 4px;
  color: #333333;
  font-size: 13px;
  font-weight: 700;
}
.calendar-view-page-schedule .fc .fc-daygrid-day-top {
  justify-content: center;
}
.calendar-view-page-schedule .fc .fc-daygrid-day-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}
.calendar-view-page-schedule .fc .fc-daygrid-day-number {
  color: #333333;
}
.calendar-view-page-schedule .fc td.fc-day-past .fc-daygrid-day-number {
  color: #9f9f9f;
}
.calendar-view-page-schedule .fc td.fc-day-today .fc-daygrid-day-frame {
  background: #e19493;
}
/* .calendar-view-page-schedule .fc-daygrid-day-events{
  background-color: #808080;
} */
.calendar-view-page-schedule .has-events .fc-daygrid-day-events {
  background-color: #808080;
}
.calendar-view-page-schedule .booked-day {
  background-color: #808080; /* Set your desired background color */
  /* Add any other styles as needed */
}
`, "",{"version":3,"sources":["webpack://./app/pages/Transferee/schedules/Schedules.css"],"names":[],"mappings":"AAAA;;gEAEgE;AAChE;EACE,cAAc;EACd,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;;GAEG;AACH;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;;EAEpB,gCAAgC;EAChC,YAAY;AACd;AACA;;;EAGE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;AACA;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;;EAEtB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,QAAQ;;EAER,MAAM;AACR;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,OAAO;EACP,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;EAOE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,MAAM;EACN,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;;;EAIE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;EAKE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,iCAAiC;EACjC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;;;EAKE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,OAAO;EACP,MAAM;EACN,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gEAAgE;EAChE,6DAA6D;EAC7D,2DAA2D;EAC3D,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;EAIE,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;;CAEC;;AAED,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;;EAElB,uCAAuC;EACvC,mBAAmB;EACnB,gCAAgC;EAChC,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA,cAAc;;AAEd;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE;;;iCAG6B;EAC/B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4DAA4D;;AAE5D;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;;;;;;;EAOE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;;EAEf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;EAaE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB;gEAC8D;EAC9D,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;EAChC;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;;EAEf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;GAEG;AACH;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;;;;;;;;;EAUE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;AACA;AACA;EACE;mBACiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE;mBACiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;;EAEd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE;;;;;;GAMC;AACH;AACA;EACE;;;;;;GAMC;AACH;AACA;EACE;;;;;;GAMC;AACH;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;;EAEtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,WAAW;EACb;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;AACzB;AACA;;GAEG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA,yBAAyB;AACzB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;;EAEf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;;EAEf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,mCAAmC;AACrC","sourcesContent":["/*=============================================================\n                Schedules Css\n===============================================================*/\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbody .fc {\n  font-size: 1em;\n}\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5em;\n}\n/* .fc-icon-chevron-left:before {\n  content: \"î¤€\";\n} */\n.calendar-view-page-schedule .fc-button .fc-icon {\n  font-size: 25px !important;\n  line-height: 17px;\n  color: #717171;\n}\n\n.fc-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-size: 1em;\n  line-height: 1.5;\n  border-radius: 0.25em;\n}\n.fc-icon {\n  font-family: \"fcicons\" !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.fc-button .fc-icon {\n  vertical-align: middle;\n}\n.calendar-view-page-schedule .fc-button .fc-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 25px !important;\n  line-height: 17px;\n  color: #717171;\n}\n.fc-header-toolbar .fc-button-primary {\n  color: #19242e;\n  border-color: #2c3e50;\n  outline: 0px !important;\n  box-shadow: none !important;\n  text-transform: capitalize;\n  background: transparent;\n}\n.calendar-view-page-schedule .fc-button {\n  padding: 0px 20px;\n  border: none;\n}\n.fc {\n  direction: ltr;\n  text-align: left;\n}\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled),\nbutton:not(:disabled) {\n  cursor: pointer;\n}\n.fc-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.fc {\n  direction: ltr;\n  text-align: left;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n\n  box-shadow: 0px 0px 10px #b5b1b1;\n  padding: 5px;\n}\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #999999;\n}\n.rbc-off-range-bg {\n  background: #e5e5e5;\n}\n.rbc-header {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-header + .rbc-header {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n.rbc-today {\n  background-color: #eaf6ff;\n}\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #373a3c;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 0px solid #ccc;\n  padding: 0.375rem 1rem;\n  border-radius: 25px;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: 0px 2px 5px #636363;\n  background-color: #e1241a;\n  color: #ffffff;\n}\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus {\n  color: #ffffff;\n  background-color: #e1241a;\n  outline: 0px;\n  box-shadow: 0px 2px 5px #636363;\n}\n.rbc-toolbar button:focus,\n.rbc-toolbar button:hover {\n  color: #ffffff;\n  background-color: #e1241a;\n  outline: 0px;\n  box-shadow: 0px 2px 5px #636363;\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.rbc-btn-group > button:nth-child(4n) {\n  display: none;\n}\n\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n.rbc-event {\n  border: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.rbc-slot-selecting .rbc-event {\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event:focus {\n  outline: 5px auto #3b99fc;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #ddd;\n\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n}\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -webkit-flex-basis: 0px;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #ddd;\n}\n.rbc-date-cell {\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n  min-height: 100px;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #ddd;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #ddd;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" Â»\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"Â« \";\n}\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #ddd;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  border: 1px solid #265985;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #f7f7f7;\n}\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n  position: -webkit-sticky;\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #ddd;\n  z-index: 10;\n  margin-right: -1px;\n}\n.rbc-time-view-resources .rbc-time-header {\n  overflow: hidden;\n}\n.rbc-time-view-resources .rbc-time-header-content {\n  min-width: auto;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -webkit-flex-basis: 0px;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n}\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-view-resources .rbc-day-slot {\n  min-width: 140px;\n}\n.rbc-time-view-resources .rbc-header,\n.rbc-time-view-resources .rbc-day-bg {\n  width: 140px;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  -webkit-flex-basis: 0 px;\n  -ms-flex-preferred-size: 0 px;\n  flex-basis: 0 px;\n}\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px;\n}\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #ddd;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n  border-left: 1px solid #ddd;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #ddd;\n}\n.rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-header-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #ddd;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #ddd;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #ddd;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  margin-left: -8px;\n  position: absolute;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"]\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"]\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"top\"]\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"]\n  .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n}\n\n.react-datepicker {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n  margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] {\n  margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] {\n  margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] {\n  margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ccc;\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled,\n.react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ccc;\n}\n\n.react-datepicker__navigation--next--with-time:not(\n    .react-datepicker__navigation--next--with-today-button\n  ) {\n  right: 80px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled,\n.react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 70px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box {\n  width: 70px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range:not(\n    .react-datepicker__day--in-range\n  ) {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range\n  .react-datepicker__day--in-range:not(\n    .react-datepicker__day--in-selecting-range\n  ) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover\n  .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n  .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n  .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n  .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ccc;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover\n  .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover\n  .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover\n  .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover\n  .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover\n  .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover\n  .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: #216ba5;\n  border-radius: 50%;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  content: \"\\00d7\";\n  cursor: pointer;\n  font-size: 12px;\n  height: 16px;\n  width: 16px;\n  line-height: 1;\n  margin: -8px auto 0;\n  padding: 2px;\n  position: absolute;\n  right: 0px;\n  text-align: center;\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled,\n.react-datepicker__portal\n  .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled,\n.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-confirm-alert-blur {\n  filter: url(#gaussian-blur);\n  filter: blur(2px);\n  -webkit-filter: blur(2px);\n}\n\n.react-confirm-alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999999999;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: center;\n  -ms-align-items: center;\n  align-items: center;\n  opacity: 0;\n  -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n  animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n}\n\n.react-confirm-alert {\n  width: 400px;\n  padding: 30px;\n  text-align: center;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n  color: #666;\n}\n\n.react-confirm-alert-svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.react-confirm-alert > h1 {\n  margin-top: 0;\n}\n\n.react-confirm-alert > h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.react-confirm-alert-button-group {\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  display: -o-flex;\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.react-confirm-alert-button-group > button {\n  outline: none;\n  background: #d9534f;\n  border: none;\n  display: inline-block;\n  padding: 6px 18px;\n  color: #fff;\n  margin-right: 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.react-confirm-alert-button-group > button:nth-child(1) {\n  outline: none;\n  background: #0088cc;\n  border: none;\n  display: inline-block;\n  padding: 6px 18px;\n  color: #fff;\n  margin-right: 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n@-webkit-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes react-confirm-alert-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.calender-rightside {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.calendar-view-page-schedule .calender-rightside {\n  height: auto;\n}\n\n.calender-rightside .ant-select {\n  width: 100%;\n  border-radius: 0px;\n}\n.calender-rightside .ant-select-selection {\n  background-color: #e1241a;\n  color: #ffffff;\n  border-radius: 0px;\n}\n.calender-rightside .ant-select-arrow {\n  color: #ffffff;\n}\n.calender-rightside .item p {\n  color: #000000;\n  font-size: 12px;\n}\n.calender-rightside .item p a {\n  width: 20px;\n  display: inline-block;\n  color: green;\n}\n.calender-rightside .item p b {\n  font-weight: 400;\n}\n.calender-rightside .item p span {\n  background: #ffffff;\n  color: #06b4e0;\n  padding: 2px 5px;\n  font-size: 11px;\n  width: 70px;\n  display: inline-block;\n  text-align: center;\n  float: right;\n}\n\n.soloprofilepage .progressbar {\n  margin-top: 40px;\n}\n\n.soloprofilepage .progressbar .stepwizard-step p {\n  margin-top: 10px;\n  margin-left: -15%;\n  font-size: 10px;\n}\n.soloprofilepage .progressbar .stepwizard-step.p2 p {\n  margin-left: -5%;\n}\n\n.soloprofilepage .progressbar .stepwizard-row {\n  display: table-row;\n  width: 100%;\n}\n\n.soloprofilepage .progressbar .stepwizard {\n  display: table;\n  width: 80%;\n  position: relative;\n  margin: auto;\n}\n\n.soloprofilepage .progressbar .stepwizard-step button[disabled] {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important;\n}\n\n.soloprofilepage .progressbar .stepwizard-row:before {\n  top: 25%;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 68%;\n  height: 1px;\n  background-color: #ccc;\n  z-order: 0;\n}\n\n.soloprofilepage .progressbar .stepwizard-step {\n  display: table-cell;\n  position: relative;\n  width: 330px;\n}\n\n.soloprofilepage .progressbar .btn-circle {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  padding: 6px 0;\n  font-size: 12px;\n  line-height: 1.428571429;\n  border-radius: 15px;\n  background: #f0f1f6;\n}\n.soloprofilepage .progressbar .btn-primary {\n  color: #fff;\n  background-color: #e1362d;\n  width: 40px;\n  height: 40px;\n  line-height: 20px;\n  border-radius: 50%;\n  border: 0px;\n  padding: 10px;\n}\n.soloprofilepage .progressbar .btn-primary .fa-circle {\n  color: #ffffff;\n}\n.soloprofilepage .progressbar .fa-circle {\n  color: #e1362d;\n}\n\n/*======================= popup ========================*/\n.myModalconfirmdes .close {\n  float: inherit;\n  text-align: right;\n  background: #dadbe6;\n  opacity: 1;\n  display: block;\n  margin: auto;\n  margin-right: 0px;\n  margin-top: 10px;\n  color: #ffffff;\n  padding: 0px 0px 5px 0px;\n  width: 35px;\n  border-radius: 50%;\n  height: 35px;\n  line-height: 30px;\n  text-align: center;\n  top: 0px;\n  position: absolute;\n  font-size: 35px;\n  font-weight: 100;\n  right: 10px;\n}\n.myModalconfirmdes .close:hover,\n.myModalconfirmdes .close:focus {\n  opacity: 1 !important;\n  background: #bcbaba;\n  outline: 0px;\n}\n.myModalconfirmdes .modal-content {\n  background: #f0f1f7;\n  border-radius: 10px;\n  width: 600px;\n  margin: auto;\n  border: 0px;\n  margin-top: 20px;\n}\n\n.myModalconfirmdes .modal-content.modal-content22 {\n  color: #e1362d;\n  font-size: 32px;\n  text-align: center;\n  margin: 0 10px;\n  width: calc(100% - 20px);\n  border-radius: 0px;\n  padding: 10px 0;\n  margin-bottom: 2px;\n  background: transparent;\n  border: 0px;\n  padding-top: 30px;\n}\n.myModalconfirmdes .modal-content.modal-content22 b {\n  font-weight: normal;\n}\n.myModalconfirmdes .modal-title {\n  font-size: 28px;\n  font-weight: 400;\n  padding-right: 20px;\n}\n.myModalconfirmdes p {\n  margin: 0px;\n  padding-top: 10px;\n}\n.myModalconfirmdes p.p1 {\n  font-size: 12px;\n  font-weight: bold;\n}\n.myModalconfirmdes p.p2 {\n  background: #fff;\n  padding: 5px 10px;\n  color: #cac7c7;\n  border: 1px solid #cccccc;\n  border-radius: 20px;\n}\n.myModalconfirmdes p.p2select {\n  padding: 0px;\n  color: #cac7c7;\n  border: 0px solid #cccccc;\n}\n.myModalconfirmdes p.p2select .custom-select {\n  border-radius: 40px;\n  color: #cac7c7;\n  height: 32px;\n  padding: 4px 10px;\n}\n.myModalconfirmdes p.p2select input {\n  border-radius: 40px;\n  color: #cac7c7;\n  height: 32px;\n  padding: 4px 10px;\n}\n.myModalconfirmdes .row.no-gutters {\n  border-bottom: 1px solid #cccccc;\n  padding: 10px 0px;\n  margin: 0px 10px;\n}\n.myModalconfirmdes .row.no-gutters:last-child {\n  border: 0px;\n}\n.myModalconfirmdes p.p3 {\n  text-align: right;\n  font-size: 18px;\n  font-weight: 600;\n  color: #8a8383;\n}\n\n.myModalconfirmdes ul li {\n  display: inline-block;\n  padding: 1px 4px;\n  border: #ffff;\n  background: #ffffff;\n  border-radius: 50%;\n  height: 30px;\n  width: 30px;\n  line-height: 27px;\n  text-align: center;\n  border: 1px solid #cccccc;\n}\n.myModalconfirmdes ul li a {\n  display: block;\n  color: #827d7d;\n  text-decoration: none;\n  font-size: 14px;\n}\n.myModalconfirmdes ul li.active {\n  background: #dcd9d9;\n  border-color: #2f2c2c;\n}\n.myModalconfirmdes ul li.active a {\n  color: #222222;\n  font-weight: 500;\n}\n.myModalconfirmdes .modal-header,\n.myModalconfirmdes .modal-footer {\n  background: #ffffff;\n  padding-bottom: 5px;\n}\n\n#myModalService.myModalconfirmdes .modal-dialog {\n  height: 100%;\n}\n\n#scheduleappointment .fc-button-primary {\n  background: transparent;\n  border: 0px;\n  color: #071822;\n  text-transform: capitalize;\n  font-size: 16px;\n  padding: 5px 15px;\n  letter-spacing: 1px;\n}\n#scheduleappointment .fc-button-primary.fc-button-active,\n#scheduleappointment .fc-button-primary:not(:disabled):active:focus,\n#scheduleappointment .fc-button-primary:not(:disabled).fc-button-active:focus,\n#scheduleappointment .fc-button-primary:hover {\n  box-shadow: 0px 2px 5px #636363;\n  background-color: #e1241a;\n  color: #ffffff;\n  border-radius: 30px;\n  outline: 0px;\n  opacity: 1;\n}\n#scheduleappointment .fc-toolbar h2 {\n  font-size: 1.75em;\n  margin: 0;\n  font-size: 16px;\n}\n#scheduleappointment .fc-timeGrid-view .fc-day-grid {\n  display: none;\n}\n#scheduleappointment hr.fc-divider {\n  display: none;\n}\n#scheduleappointment .fc-nonbusiness {\n  background: #cecece;\n}\n#act #scheduleappointment .fc-event .fc-content {\n  color: #fff;\n  font-size: 12px;\n  text-align: center;\n}\n#scheduleappointment .fc {\n  font-size: 1em;\n  box-shadow: 0px 0px 10px #b5b1b1;\n  padding: 5px;\n}\n#scheduleappointment .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 5px;\n}\n.eventColor {\n  background: #cecece;\n}\n\n/*\n spinner\n*/\n\n/* Absolute Center Spinner */\n.loading {\n  position: fixed;\n  z-index: 999;\n  overflow: show;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 50px;\n  height: 50px;\n}\n\n/* Transparent Overlay */\n.loading:before {\n  content: \"\";\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n/* :not(:required) hides these rules from IE9 and below */\n.loading:not(:required) {\n  /* hide \"loading...\" text */\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.loading:not(:required):after {\n  content: \"\";\n  display: block;\n  font-size: 10px;\n  width: 50px;\n  height: 50px;\n  margin-top: -0.5em;\n\n  border: 5px solid rgba(33, 150, 243, 1);\n  border-radius: 100%;\n  border-bottom-color: transparent;\n  -webkit-animation: spinner 1s linear 0s infinite;\n  animation: spinner 1s linear 0s infinite;\n}\n\n/* Animation */\n\n@-webkit-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1300px) {\n  .myModalconfirmdes .modal-content.modal-content22 {\n    font-size: 25px;\n  }\n  .myModalconfirmdes .modal-title {\n    font-size: 20px;\n  }\n  .myModalconfirmdes .modal-header img {\n    width: 35px;\n  }\n  .myModalconfirmdes .row.no-gutters {\n    padding: 5px 10px;\n  }\n  .myModalconfirmdes p.p2 {\n    height: 32px;\n    padding: 3px 10px;\n  }\n}\n@media (max-width: 1100px) {\n  #scheduleappointment .fc-button-primary {\n    font-size: 12px;\n    padding: 3px 10px;\n  }\n  #scheduleappointment .fc-toolbar h2 {\n    font-size: 12px;\n  }\n  .calender-rightside .item p {\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    font-size: 10px;\n  }\n  .calender-rightside .item p span {\n    height: 20px;\n  }\n  .calendar-view-page-schedule .main-view .item ul.hours-view li {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  #scheduleappointment .fc-button-primary {\n    font-size: 10px;\n    padding: 3px 10px;\n  }\n  #scheduleappointment .fc-toolbar h2 {\n    font-size: 10px;\n  }\n  .fc th {\n    font-size: 10px;\n  }\n  .fc-ltr .fc-axis {\n    font-size: 11px;\n    text-align: center;\n  }\n  .calender-rightside .item p span {\n    display: block;\n    width: 100%;\n    margin-top: 5px;\n    float: inherit;\n  }\n  .calender-rightside .item p {\n    font-size: 9px;\n    font-weight: bold;\n    display: block;\n  }\n  .soloprofilepage .progressbar .stepwizard {\n    width: 100%;\n  }\n  .soloprofilepage .progressbar .stepwizard-step p {\n    font-weight: bold;\n    font-size: 10px;\n  }\n\n  .soloprofilepage .profiletabone .property-rrswatch a {\n    font-size: 10px;\n  }\n  .soloprofilepage .profiletabone .property-rrswatch label {\n    position: relative;\n    top: 4px;\n  }\n  .soloprofilepage .profiletabone i {\n    padding-top: 10px;\n    padding-bottom: 20px;\n    font-size: 10px;\n    color: #8a8585;\n    text-align: center;\n    font-weight: 700;\n  }\n  .calendar-view-page-schedule .main-view .item ul {\n    margin: auto;\n  }\n  .calendar-view-page-schedule .main-view .item ul li {\n    margin-right: 15px;\n  }\n}\n.myModalconfirmdes .modal-dialog {\n  height: calc(100vh - 80px);\n}\n@media screen and (max-width: 767px) {\n  .myModalconfirmdes .modal-content {\n    width: 100%;\n  }\n  .myModalconfirmdes .modal-content.modal-content22 {\n    font-size: 18px;\n  }\n  .myModalconfirmdes .close {\n    width: 27px;\n    height: 28px;\n    line-height: 28px;\n    font-size: 20px;\n  }\n  .myModalconfirmdes .modal-title {\n    font-size: 15px;\n    font-weight: 600;\n  }\n  .myModalconfirmdes p.p2 {\n    margin-bottom: 10px;\n  }\n  .myModalconfirmdes p {\n    text-align: center;\n  }\n  .myModalconfirmdes p.p3 {\n    text-align: center;\n  }\n  .myModalconfirmdes .modal-dialog {\n    height: auto;\n  }\n  .myModalconfirmdes .modal-footer .btn {\n    /* font-size: 10px;\n    font-weight: bold;\n    padding: 5px 15px;\n    margin-top: 0px !important; */\n  }\n  #moveDelete .modal-title {\n    font-size: 15px;\n    font-weight: 700;\n  }\n  #moveDelete .input-group {\n    flex-direction: column;\n  }\n  #moveDelete .react-datepicker__input-container,\n  #moveDelete .input-group-prepend {\n    display: block;\n  }\n  .react-confirm-alert {\n    width: 90%;\n  }\n  .calendar-view-page-schedule .main-view .item ul.hours-view {\n    flex-direction: column;\n  }\n}\n\n@media (min-width: 320px) {\n  .myModalconfirmdes .modal-dialog {\n    max-width: 80%;\n    margin: 1.75rem auto;\n    margin-top: 50px;\n    background: #ffffff;\n  }\n}\n\n#moveDelete .input-group-prepend {\n  float: left;\n  margin-bottom: 15px;\n}\n#moveDelete .react-datepicker-wrapper {\n  width: 100%;\n}\n#moveDelete .react-datepicker__input-container {\n  width: 100%;\n}\n\n#moveDelete .col-form-label {\n  text-align: right;\n}\n\n/**--------------------------28/01/2020 ------------------**/\n\n@media (max-width: 991px) {\n  .soloprofilepage .fc-toolbar.fc-header-toolbar h2 {\n    font-size: 16px;\n    font-weight: 700;\n  }\n}\n@media (max-width: 767px) {\n  .soloprofilepage .fc-toolbar.fc-header-toolbar h2 {\n    padding-top: 10px;\n  }\n  #myModalService.myModalconfirmdes ul {\n    text-align: center !important;\n  }\n}\n\n.new_modal_pop .form-para p.p2 {\n  height: 38px;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  padding: 7px 10px;\n  border-radius: 5px;\n  color: #4e4e4e;\n}\n.new_modal_pop .form-para p.p3 input {\n  height: 38px;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  padding: 7px 10px;\n  border-radius: 5px;\n  color: #4e4e4e;\n}\n.new_modal_pop .form-para .ant-select-selection--multiple ul {\n  margin: 0px;\n}\n.new_modal_pop .form-para .ant-select-selection--multiple > ul > li,\n.new_modal_pop\n  .form-para\n  .ant-select-selection--multiple\n  .ant-select-selection__rendered\n  > ul\n  > li {\n  height: 30px;\n  margin-top: 3px;\n  line-height: 26px;\n}\n/** properties thumbnail checkkk css*/\n.new_modal_pop .properties_list ul {\n  list-style-type: none;\n  text-align: left;\n  padding: 0px;\n  margin: 0;\n  padding-top: 10px;\n}\n\n.new_modal_pop .properties_list ul li {\n  display: inline-block;\n  width: auto;\n  height: auto;\n  background: transparent;\n  border: 0px;\n  position: relative;\n}\n\n.new_modal_pop .properties_list input[type=\"checkbox\"][id^=\"myCheckbox\"] {\n  display: none;\n}\n\n.new_modal_pop .properties_list input[type=\"checkbox\"][id^=\"mybox\"] {\n  display: none;\n}\n\n.new_modal_pop .properties_list label {\n  border: 2px solid #fff;\n  padding: 0px;\n  display: block;\n  position: relative;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.new_modal_pop .properties_list label:before {\n  background-color: white;\n  color: white;\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  border: 1px solid grey;\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  line-height: 23px;\n  transition-duration: 0.4s;\n  transform: scale(0);\n  font-size: 20px;\n}\n\n.new_modal_pop .properties_list label img {\n  height: 135px;\n  width: 140px;\n  transition-duration: 0.2s;\n  transform-origin: 50% 50%;\n}\n\n.new_modal_pop .properties_list :checked + label {\n  border-color: #ffb0b0;\n}\n\n.new_modal_pop .properties_list :checked + label:before {\n  content: \"âœ“\";\n  background-color: #e32726;\n  transform: scale(1);\n  border-color: #e32726;\n  z-index: 1;\n  font-size: 20px;\n  top: -6px;\n  left: -6px;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  line-height: 23px;\n}\n\n.new_modal_pop .properties_list :checked + label img {\n  z-index: -1;\n}\n.new_modal_pop .properties_list label p {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 13px;\n  line-height: 16px;\n  bottom: 0px;\n  width: 100%;\n  color: #ffffff;\n  padding: 10px;\n  word-break: break-word;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  bottom: 0px;\n  text-align: center;\n}\n.new_modal_pop .properties_list label:hover {\n  background: rgba(0, 0, 0, 1);\n}\n.new_modal_pop .properties_list label:hover img {\n  opacity: 0.3;\n}\n.new_modal_pop .properties_list label:hover p {\n  display: flex !important;\n  transition: all 0.3s;\n}\n.new_modal_pop .properties_list .p_list {\n  position: relative;\n  margin-top: 10px;\n  border: 1px solid #dad8d8;\n  border-radius: 5px;\n}\n.new_modal_pop .properties_list .p_list h1 {\n  font-size: 18px;\n  padding-top: 10px;\n  position: absolute;\n  top: -13px;\n  background: #f2f2f2;\n  padding: 0px 5px;\n  left: 15px;\n}\n.new_modal_pop .ul_select_list {\n  border: 1px dashed #ededed;\n  font-weight: 400;\n  white-space: nowrap;\n  color: #d0d0d0;\n  font-size: 17px;\n\n  padding: 0;\n  padding-left: 16px;\n  padding-right: 0px;\n  min-height: 40px;\n  line-height: 40px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.new_modal_pop .ul_select_list span.main_span .ant-select.ant-select-enabled {\n  width: 200px !important;\n  padding-right: 12px;\n}\n.new_modal_pop .ul_select_list span.main_span .ant-select-selection--multiple {\n  border: 0px;\n  background: #ffffff;\n  border: 1px solid #e4e4e4;\n}\n.new_modal_pop\n  .ul_select_list\n  span.main_span\n  .ant-select-selection--multiple\n  > ul\n  > li,\n.new_modal_pop\n  .ul_select_list\n  span.main_span\n  .ant-select-selection--multiple\n  .ant-select-selection__rendered\n  > ul\n  > li {\n  width: 100% !important;\n}\n.new_modal_pop .ul_select_list span.main_span {\n  position: relative;\n}\n.new_modal_pop .ul_select_list span.main_span .fa.fa-caret-down {\n  color: #717171;\n  position: absolute;\n  top: 13px;\n  right: 20px;\n  display: none;\n}\n.new_modal_pop .next_input .floating-label {\n  position: relative;\n  height: 42px;\n  background: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 0px;\n  color: #4e4e4e;\n}\n.new_modal_pop .next_input .floating-label input.form-control {\n  border: 0px;\n  padding: 5px 10px 5px 10px;\n  height: 40px;\n  border-radius: 0px;\n  color: #717171;\n  line-height: 35px;\n}\n.new_modal_pop .next_input .floating-label .fa.fa-map-marker {\n  position: absolute;\n  top: 0;\n  right: 0px;\n  font-size: 20px;\n  color: #d6d4d4;\n  background: #fbfbfb;\n  padding-top: 10px;\n  padding-left: 16px;\n  bottom: 0px;\n  width: 40px;\n}\n.new_modal_pop .floating-label .fa.fa-map-marker {\n  position: absolute;\n  top: 20px;\n  right: 0px;\n  font-size: 20px;\n  color: #d6d4d4;\n  padding-top: 10px;\n  padding-left: 16px;\n  bottom: 0px;\n  width: 40px;\n}\n.new_modal_pop .ul_select_list.text_overfloww .main_span {\n  width: 250px;\n  padding-top: 7px;\n  line-height: 25px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  color: #797979;\n  text-align: right;\n  padding-right: 15px;\n  white-space: initial;\n}\n.new_modal_pop .ul_select_list.text_overfloww .main_span:hover {\n  white-space: initial;\n  transition: All 0.3s;\n}\n.new_modal_pop .properties_list .owl-carousel.owl-drag .owl-item {\n  text-align: center;\n}\n.calendarIndicators-view-top {\n  position: relative;\n}\n.calendarIndicators-view {\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  top: 49px;\n  left: 0px;\n  right: 0px;\n}\nul.calendarIndicators.main {\n  box-shadow: 0px 0px 4px #b7b7b7;\n  line-height: 20px;\n  height: auto;\n  padding: 0px !important;\n  border-radius: 5px;\n}\nul.calendarIndicators.main li {\n  color: #333333;\n  padding: 7px 10px 5px 10px;\n  line-height: 15px;\n  margin: 0;\n}\nul.calendarIndicators.main2 li span {\n  font-weight: 500;\n  color: #000000;\n}\nul.calendarIndicators.main2 li {\n  color: #ffffff;\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n  outline: 0px;\n  box-shadow: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 5px;\n  padding: 7px 10px;\n  margin-top: 0px;\n}\nul.calendarIndicators.main2 li:first-child {\n  background: #6effaa;\n  border-bottom: 1px solid #cccccc;\n}\nul.calendarIndicators.main2 li:last-child {\n  background: #4bc5ff;\n  margin: 0px;\n}\n.main_content .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 50px;\n}\n\n@media (max-width: 991px) {\n  .main_content .fc-toolbar.fc-header-toolbar {\n    margin-bottom: 65px;\n  }\n  ul.calendarIndicators {\n    width: 48%;\n  }\n  ul.calendarIndicators.main2 li {\n    padding: 7px 5px;\n  }\n  ul.calendarIndicators.main li {\n    font-size: 12px;\n  }\n}\n@media (max-width: 767px) {\n  #myModalService.new_modal_pop .btn.theme-btn {\n    margin: auto;\n    margin-bottom: 15px;\n    display: inline-block;\n    width: auto;\n  }\n  .main_content .fc-toolbar.fc-header-toolbar {\n    margin-bottom: 120px;\n  }\n  .calendarIndicators-view {\n    top: 140px;\n    flex-direction: column;\n  }\n  ul.calendarIndicators {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n  ul.calendarIndicators.main {\n    margin-bottom: 13px;\n  }\n}\n@media (max-width: 500px) {\n  .modal.new_modal_pop .modal-content h6::before {\n    display: none;\n  }\n  .new_modal_pop .ul_select_list {\n    flex-direction: column;\n  }\n  .new_modal_pop .ul_select_list span.main_span .ant-select.ant-select-enabled {\n    width: 100% !important;\n  }\n  .new_modal_pop .properties_list .properties_list_owl-carousel ul {\n    width: 70%;\n    margin: auto;\n  }\n  #myModalService.new_modal_pop .btn.theme-btn {\n    display: block;\n    width: 200px;\n    margin: auto !important;\n    margin-bottom: 10px !important;\n  }\n}\n.new_modal_pop .properties_list input[type=\"checkbox\"][id^=\"sabox\"] {\n  display: none;\n}\n\n.fc-time-grid-event .fc-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  text-align: center;\n  color: #e0e0e0;\n  font-size: 13px;\n}\n.fc-scroller.fc-time-grid-container .fc-nonbusiness {\n  background: #b1b1b1;\n}\n.fc-time-grid .fc-slats td {\n  background: rgba(202, 202, 202, 0.3);\n  background: transparent;\n}\n.fc-header-toolbar .fc-button-primary,\n.fc-header-toolbar .fc-button-primary:focus {\n  color: #19242e;\n  border-color: #2c3e50;\n  outline: 0px !important;\n  box-shadow: none !important;\n  text-transform: capitalize;\n  background: transparent;\n}\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5em;\n}\n.fc-header-toolbar .fc-button-primary:hover {\n  color: #ffffff;\n  border-color: #2c3e50;\n  background: #19242e;\n  transition: all 0.5s;\n}\n.fc-header-toolbar .fc-button-primary:disabled,\n.fc-header-toolbar .fc-button-primary:disabled:hover {\n  color: #19242e;\n  background-color: transparent;\n  border-color: #2c3e50;\n  opacity: 0.3;\n  cursor: not-allowed;\n}\nbutton:not(:disabled) {\n  cursor: pointer;\n}\n.calendar-view-page-schedule .fc-button {\n  padding: 0px 20px;\n  border: none;\n}\n.fc-button-group > .fc-button:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.fc-button-group {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.calendar-view-page-schedule .main-view .item h2 {\n  margin: 5px 0px;\n\n  color: #333333;\n  text-align: center;\n}\n.calendar-view-page-schedule .main-view .item .calendar h2 {\n  font-size: 18px;\n}\n.calendar-view-page-schedule .fc-button .fc-icon {\n  font-size: 25px !important;\n  line-height: 17px;\n  color: #717171;\n}\n\n/* .fc-icon-chevron-left:before {\n  content: \"î¤€\";\n} */\n.calendar-view-page-schedule .fc-button .fc-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 25px !important;\n  line-height: 17px;\n  color: #717171;\n}\n.calendar-view-page-schedule .fc-button {\n  padding: 0px 20px;\n  border: none;\n}\n.fc-time-grid .fc-time-grid-event.fc-event {\n  border: 0px;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-content,\n.fc-unthemed .fc-popover,\n.fc-unthemed .fc-list-view,\n.fc-unthemed .fc-list-heading td {\n  border-color: #cacaca !important;\n}\n.fc-view .fc-body {\n  background: #ffffff;\n}\n.fc-time-grid .fc-slats td.fc-axis {\n  background: #f0f1f7;\n}\n.fc-timeGrid-view .fc-day-grid {\n  display: none;\n}\nhr.fc-divider.fc-widget-header {\n  display: none;\n}\n.fc-view-container * {\n}\n.fc-view-container .fc-day-header.fc-widget-header {\n  /* background: #19242e;\n  color: #ffffff; */\n  font-weight: 700;\n  padding: 5px;\n  font-size: 13px;\n}\n.fc {\n  direction: ltr;\n  text-align: left;\n}\n.fc-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.fc-time-grid .fc-slats td.fc-axis {\n  /* background: #19242e;\n  color: #ffffff; */\n  font-weight: 700;\n  padding: 5px;\n  font-size: 12px;\n}\n.fc-axis.fc-widget-header {\n  position: relative;\n}\n.fc-axis.fc-widget-header::after {\n  content: \"\\f017\";\n  font-family: FontAwesome;\n  position: absolute;\n  top: 3px;\n  left: 50%;\n  font-size: 16px;\n  font-weight: 100;\n  transform: translateX(-50%);\n}\n\n.fc-view-container .fc-title {\n  /* color: red; */\n  font-size: 9px;\n  font-weight: 900;\n}\n\n.ds-profile-page .calendar-view-page-schedule h1 {\n  font-size: 16px;\n  font-weight: 400;\n  color: #aaaaaa;\n  margin-bottom: 0px;\n}\n.calendar-view-page-schedule .main-view {\n  display: flex;\n  justify-content: space-between;\n}\n\n.calendar-view-page-schedule .main-view .item {\n  padding: 10px 20px;\n  width: 25%;\n}\n.calendar-view-page-schedule .main-view .item:nth-child(2) {\n  width: 50%;\n}\n.calendar-view-page-schedule .main-view .item .image-circle-view {\n  width: 170px;\n  height: 170px;\n  overflow: hidden;\n  margin: auto;\n  border-radius: 50%;\n  border: 3px solid #cccc;\n  margin-bottom: 15px;\n}\n.calendar-view-page-schedule .main-view .item .image-circle-view img {\n  width: 100%;\n  height: 100%;\n}\n.calendar-view-page-schedule .main-view .item .bg-color {\n  background: #ffffff;\n  border-radius: 7px;\n  padding: 30px 15px;\n  box-shadow: 0px 0px 4px #b7b7b7;\n}\n.calendar-view-page-schedule .main-view .item img {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.calendar-view-page-schedule .main-view .item h1 {\n  font-size: 16px;\n  font-weight: 400;\n  color: #aaaaaa;\n  margin-bottom: 0px;\n}\n.calendar-view-page-schedule .main-view .item h2 {\n  margin: 5px 0px;\n  font-size: 30px;\n  color: #333333;\n  text-align: center;\n}\n\n.calendar-view-page-schedule .main-view .item h3 {\n  margin: 5px 0px;\n  font-size: 15px;\n  color: #7d7d7d;\n  font-weight: 400;\n}\n\n.calendar-view-page-schedule .main-view .item ul {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n}\n.calendar-view-page-schedule .main-view .item ul li {\n  font-size: 14px;\n  font-weight: 400;\n  color: #333333;\n  margin-bottom: 0px;\n  display: flex;\n  padding-bottom: 5px;\n  margin-right: 0px;\n}\n.calendar-view-page-schedule .main-view .item .bg-color.bg-color2 {\n  background: #d7c7fa;\n  color: #000000;\n}\n.calendar-view-page-schedule .main-view .item ul.main {\n  box-shadow: none;\n}\n.calendar-view-page-schedule .main-view .item ul.main li {\n  color: #000000;\n  padding: 5px 10px;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  font-weight: 500;\n  line-height: 18px;\n}\n.calendar-view-page-schedule .main-view .item ul li i {\n  color: #aaaaaa;\n  position: relative;\n  top: 1px;\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.calendar-view-page-schedule .main-view .item ul.hours-view li {\n  justify-content: space-between;\n  margin: 0px 0px;\n  font-size: 13px;\n  background: transparent;\n  padding: 10px 0px;\n  border-radius: 0px;\n}\n.calendar-view-page-schedule .main-view .item h4 {\n  margin: 5px 0px;\n  font-size: 20px;\n  color: #6e6e6e;\n  font-weight: 500;\n}\n.calendar-view-page-schedule .main-view .item h5 {\n  margin: 5px 0px;\n  font-size: 17px;\n  color: #121212;\n  font-weight: 400;\n  margin-top: 0px;\n  margin-bottom: 30px;\n}\n.calendar-view-page-schedule .main-view .item h6 {\n  margin: 5px 0px;\n  font-size: 18px;\n  color: #000000;\n  font-weight: 500;\n  margin-bottom: 15px;\n  border-bottom: 2px solid #ccc;\n  padding-bottom: 5px;\n}\n.calendar-view-page-schedule .main-view .item .clr-slots-view-bg {\n  background: #ffffff;\n  padding: 20px 15px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 4px #b7b7b7;\n}\n.calendar-view-page-schedule .a-slots {\n  max-height: 200px;\n  overflow: auto;\n  margin-bottom: 20px;\n}\n.calendar-view-page-schedule .y-appointment {\n  max-height: 240px;\n  overflow: auto;\n  margin-bottom: 20px;\n}\n.calendar-view-page-schedule .main-view .item .btn {\n  display: block;\n  border: 1px solid #121212;\n  width: 100%;\n  max-width: 240px;\n  margin-bottom: 15px;\n  color: #151515;\n\n  font-weight: 500;\n  padding: 10px 20px;\n  background: #dbdbdb;\n}\n.calendar-view-page-schedule .fc-button {\n  padding: 0px 20px;\n  border: none;\n}\n.calendar-view-page-schedule .fc-button .fc-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 25px !important;\n  line-height: 17px;\n  color: #717171;\n}\n.calendar-view-page-schedule .main-view .item .calendar h2 {\n  font-size: 18px;\n}\n.calendar-view-page-schedule .main-view .fc-scroller.fc-day-grid-container {\n  height: 100% !important;\n  overflow: auto !important;\n}\n.calendar-view-page-schedule .main-view .calendar .fc th {\n  border: 0px;\n  text-align: center;\n  padding: 10px 5px;\n}\n.calendar-view-page-schedule .fc-view-harness.fc-view-harness-active {\n  min-height: 600px;\n}\n.calendar-view-page-schedule .fc .fc-daygrid-day.fc-day-today {\n  height: auto;\n}\n\n.calendar-view-page-schedule .main-view .calendar .fc td {\n  border: 0px;\n  text-align: center;\n}\n.calendar-view-page-schedule .fc-view .fc-body {\n  background: #f7f7f7;\n}\n.calendar-view-page-schedule .fc-nonbusiness {\n  background: #f7f7f7;\n}\n.calendar-view-page-schedule .fc-row .fc-bg td {\n  border-radius: 10px;\n}\n.calendar-view-page-schedule .fc-highlight {\n  background: #2facf5;\n  opacity: 0.3;\n  border-radius: 10px;\n}\n.calendar-view-page-schedule .fc-unthemed td.fc-today {\n  background: #e19493;\n}\n.calendar-view-page-schedule\n  .main-view\n  .fc-ltr\n  .fc-dayGrid-view\n  .fc-day-top\n  .fc-day-number {\n  float: inherit;\n}\n.calendar-view-page-schedule .main-view .fc-dayGrid-view .fc-body .fc-row {\n  display: flex;\n  align-items: center;\n}\n.main_cal_indicate ul.indicators li {\n  display: inline-flex !important;\n  align-items: center;\n}\n.main_cal_indicate ul.indicators li b {\n  letter-spacing: -2px;\n  padding: 0px 10px;\n}\n.main_cal_indicate ul.indicators li span {\n  background: #e7e7e7;\n  height: 15px;\n  width: 40px;\n  display: inline-block;\n  border-radius: 7px;\n}\n.main_cal_indicate ul.indicators li.one span {\n  background: repeating-linear-gradient(\n    45deg,\n    #7f7f7f,\n    #7f7f7f 8px,\n    #7f7f7f 8px,\n    #7f7f7f 20px\n  );\n}\n.main_cal_indicate ul.indicators li.green span {\n  background: repeating-linear-gradient(\n    45deg,\n    #1967b3,\n    #1967b3 8px,\n    #1967b3 8px,\n    #1967b3 20px\n  );\n}\n.main_cal_indicate ul.indicators li.white span {\n  background: repeating-linear-gradient(\n    45deg,\n    #ffffff,\n    #ffffff 8px,\n    #ffffff 8px,\n    #ffffff 20px\n  );\n}\n.calendar-view-page-schedule ul.time-slot {\n  margin: 0px;\n  padding: 0px;\n  list-style-type: none;\n}\n.calendar-view-page-schedule ul.time-slot li {\n  margin-bottom: 10px !important;\n}\n.calendar-view-page-schedule ul.time-slot li a {\n  background: #2facf5;\n  background: #1d66b3;\n  color: #fff;\n  width: 100%;\n  min-height: 100px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none !important;\n  flex-direction: column;\n\n  font-size: 15px;\n  padding: 10px 15px;\n}\n.calendar-view-page-schedule .fc-dayGridMonth-button {\n  display: none;\n}\n.calendar-view-page-schedule .fc-header-toolbar .fc-button-primary:hover {\n  color: #ffffff;\n  border-color: #2c3e50;\n  background: #19242e;\n  transition: all 0.5s;\n  background: transparent;\n  border: none;\n}\n.calendar-view-page-schedule .fc td.fc-past {\n  color: #9f9f9f;\n}\n.calendar-view-page-schedule .fc-event {\n  /* position: relative; */\n  display: block;\n  font-size: 0.85em;\n  line-height: 1.4;\n  border-radius: 11px !important;\n  border: 0px solid #3788d8;\n  height: 12px;\n  width: 12px;\n  text-align: center;\n  padding: 0px;\n  margin: auto;\n  opacity: 1;\n  position: absolute;\n  bottom: -35px;\n}\n.calendar-view-page-schedule .main-view .calendar .fc td.avaliableDay {\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0px 0px 5px #ebebeb;\n}\n.calendar-view-page-schedule .main-view .item .main_cal_indicate ul li {\n  margin: 0px 20px;\n}\n@media (max-width: 1199px) {\n  .calendar-view-page-schedule .main-view .item .image-circle-view {\n    width: 150px;\n    height: 150px;\n  }\n  .calendar-view-page-schedule .main-view .item h2 {\n    font-size: 20px;\n    font-weight: 700;\n  }\n}\n\n@media (max-width: 991px) {\n  .calendar-view-page-schedule .main-view {\n    flex-direction: column;\n  }\n  .calendar-view-page-schedule .main-view .item {\n    width: 100%;\n    text-align: center;\n  }\n  .calendar-view-page-schedule .main-view .item ul {\n    text-align: left;\n  }\n  .calendar-view-page-schedule .main-view .item:nth-child(2) {\n    width: 100%;\n    padding: 10px 5px;\n  }\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar {\n    flex-direction: row;\n  }\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-left,\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-right {\n    width: auto;\n  }\n  .calendar-view-page-schedule .main-view .item .btn {\n    margin: auto;\n    margin-bottom: 15px;\n  }\n  .calendar-view-page-schedule ul.time-slot li a {\n    max-width: 250px;\n    margin: auto;\n  }\n}\n\n@media (max-width: 767px) {\n  .calendar-view-page-schedule .main-view {\n    flex-direction: column;\n  }\n  .calendar-view-page-schedule .main-view .item {\n    width: 100%;\n    text-align: center;\n  }\n  .calendar-view-page-schedule .main-view .item ul {\n    text-align: left;\n  }\n  .calendar-view-page-schedule .main-view .item:nth-child(2) {\n    width: 100%;\n    padding: 10px 5px;\n  }\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar {\n    flex-direction: row;\n  }\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-left,\n  .calendar-view-page-schedule .fc-toolbar.fc-header-toolbar .fc-right {\n    width: auto;\n  }\n  .calendar-view-page-schedule .fc-dayGrid-view .fc-body .fc-row {\n    min-height: 43px;\n  }\n  .calendar-view-page-schedule .main-view .item .btn {\n    margin: auto;\n    margin-bottom: 15px;\n  }\n  .main_cal_indicate ul.indicators li {\n    margin-right: 0px !important;\n    width: 100%;\n  }\n  .calendar-view-page-schedule .fc-event {\n    height: 10px;\n    width: 10px;\n  }\n}\n\n@media (max-width: 400px) {\n  .main_cal_indicate ul.indicators li {\n    font-size: 14px;\n  }\n\n  .calendar-view-page-schedule .fc-event {\n    height: 8px;\n    width: 8px;\n  }\n}\n.calendar-view-page-schedule .fc-content-skeleton tr:nth-child(2) {\n  display: none;\n}\n.calendar-view-page-schedule .past {\n  border-radius: 10px;\n  background-color: rgb(11, 0, 75);\n  height: 50%;\n}\n.calendar-view-page-schedule .activeDay {\n  border-radius: 10px;\n  background-color: #e19493 !important;\n  height: 100%;\n  margin: 0px 2px 0px 2px;\n}\n/* .activeDay {\n  background-color: red;\n} */\n.calendar-view-page-schedule .fc-day-grid {\n  min-height: 100%;\n}\n.calendar-view-page-schedule .fc-bg {\n  margin: 2px;\n}\n@-moz-document url-prefix() {\n  .calendar-view-page-schedule .activeDay {\n    height: 100%;\n  }\n  .calendar-view-page-schedule .main-view .calendar .fc td {\n    height: 100%;\n  }\n}\n/* =====modalpop styles */\n.new_modal_pop h6 {\n  color: #505050;\n  text-align: center;\n  font-size: 20px;\n  position: relative;\n  margin-bottom: 25px;\n}\n.modal-body {\n  position: relative;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n.new_modal_pop .ul_select_list {\n  border: 1px dashed #ededed;\n  font-weight: 400;\n  white-space: nowrap;\n  color: #d0d0d0;\n  font-size: 17px;\n\n  padding: 0;\n  padding-left: 16px;\n  padding-right: 0px;\n  min-height: 40px;\n  line-height: 40px;\n  display: flex;\n  justify-content: space-between;\n}\n.new_modal_pop ul.appoint_list li a {\n  position: relative;\n  display: block;\n  height: 40px;\n  line-height: 40px;\n  padding: 0;\n  padding-left: 16px;\n  padding-right: 56px;\n  text-decoration: none;\n  font-weight: 400;\n  white-space: nowrap;\n  color: #d0d0d0;\n  font-size: 17px;\n\n  border: 1px dashed #ededed;\n}\n.new_modal_pop ul.appoint_list li a span {\n  position: absolute;\n  right: 16px;\n  top: 0;\n  color: #717171;\n}\n\n.new_modal_pop ul.appoint_list li {\n  position: relative;\n  list-style-type: none;\n}\n.new_modal_pop ul.appoint_list {\n  padding: 0px;\n  margin: 0px;\n}\n.new_modal_pop .ul_select_list span.main_span {\n  position: relative;\n}\n.pd-y-50 {\n  padding: 50px 0px;\n}\n.width-60per {\n  width: 60% !important;\n  margin: auto;\n}\n\n.calendar-view-page-schedule .fc .fc-col-header-cell-cushion {\n  display: inline-block;\n  padding: 2px 4px;\n  color: #333333;\n  font-size: 13px;\n  font-weight: 700;\n}\n.calendar-view-page-schedule .fc .fc-daygrid-day-top {\n  justify-content: center;\n}\n.calendar-view-page-schedule .fc .fc-daygrid-day-frame {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n}\n.calendar-view-page-schedule .fc .fc-daygrid-day-number {\n  color: #333333;\n}\n.calendar-view-page-schedule .fc td.fc-day-past .fc-daygrid-day-number {\n  color: #9f9f9f;\n}\n.calendar-view-page-schedule .fc td.fc-day-today .fc-daygrid-day-frame {\n  background: #e19493;\n}\n/* .calendar-view-page-schedule .fc-daygrid-day-events{\n  background-color: #808080;\n} */\n.calendar-view-page-schedule .has-events .fc-daygrid-day-events {\n  background-color: #808080;\n}\n.calendar-view-page-schedule .booked-day {\n  background-color: #808080; /* Set your desired background color */\n  /* Add any other styles as needed */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
